import {Component, ViewContainerRef} from "@angular/core";
import {FUIModalsService} from "./modals.service";

@Component({
    selector: "fui-modals",
    templateUrl: "./modals.component.html",
    standalone: false
})
export class FUIModalsComponent {
    constructor(private modalsService: FUIModalsService,
                private viewContainerRef: ViewContainerRef) {
        this.modalsService.setPlaceholder(this.viewContainerRef);
    }
}
